import { styled } from '@linaria/react'

export const SelectionField = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;

  align-items: end;

  > .select {
    flex: 1;
  }

  > .split-flex,
  .has-error {
    display: flex;
    gap: 8px;
    flex: 1;
    align-self: center;
    align-content: center;
    justify-content: flex-start;

    > div {
      margin: unset;
    }
  }

  > input {
    max-width: 6.5em;
    width: fit-content;
  }

  > .icon {
    padding-bottom: 4px;
  }
`
